'use client';

export { default } from './StepLabel';
export { default as stepLabelClasses } from './stepLabelClasses';
export * from './stepLabelClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/StepLabel/index.js
// module id = 518
// module chunks = 22